import { PROTOCOL, TChannelProtocol } from '@/entities/channel';

type ChannelProtocolSource = {
  protocol?: TChannelProtocol;
  protocol_id?: TChannelProtocol;
};

export const getPhoneChangeAuthProtocol = (
  currentChannel: ChannelProtocolSource,
  resetChannel?: ChannelProtocolSource | null
): TChannelProtocol | undefined => {
  return resetChannel?.protocol ?? resetChannel?.protocol_id ?? currentChannel.protocol ?? currentChannel.protocol_id;
};

export const shouldUseWhatsappPhoneAuth = (
  currentChannel: ChannelProtocolSource,
  resetChannel?: ChannelProtocolSource | null
) => {
  return getPhoneChangeAuthProtocol(currentChannel, resetChannel) === PROTOCOL.WHATSAPP_GRAY;
};
